<template>
    <breeze-authenticated-layout>
        <template #header>
            <h2 class="font-semibold text-3xl text-gray-800 leading-tight py-2">
                Placements
            </h2>
        </template>

        <breeze-page :submenus="subMenus">
            <slot></slot>
        </breeze-page>
    </breeze-authenticated-layout>
</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated'
import BreezePage from '@/Components/Page'

export default {
    components: {
        BreezeAuthenticatedLayout,
        BreezePage
    },
    data() {
        return {
            subMenus: [{
                'title': 'Companies',
                'active': route().current('placement.company.*'),
                'route': 'placement.company.list',
                'visible': this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Company' || permission.name === 'Edit Company' || permission.name === 'View Company')
            }, {
                'title': 'Jobs',
                'active': route().current('placement.job.*'),
                'route': 'placement.job.list',
                'visible': this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Job' || permission.name === 'Edit Job' || permission.name === 'View Job')
            }]
        }
    },
}
</script>
